import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { isMobileBrowser } from '../../../environment/utils';
import Icon from '../../../icons/components/Icon';
const useStyles = makeStyles()(theme => {
    return {
        button: {
            padding: "2px",
            fill: theme.palette.iisightIcon,
            color: theme.palette.iisightIcon,
            backgroundColor: "transparent",
            border: 0,
            outline: 0,
            borderRadius: `${theme.shape.circleRadius}%`,
            "&:hover": {
                fill: theme.palette.iisightWhite,
                color: theme.palette.iisightWhite,
                backgroundColor: theme.palette.iisightGray200
            },
            "&.focus-visible": {
                outline: 0,
                boxShadow: `0px 0px 0px 2px ${theme.palette.focus01}`
            },
            "&:active": {
                fill: theme.palette.iisightGray100,
                color: theme.palette.iisightGray100,
                backgroundColor: theme.palette.iisightGray700
            },
            "&.is-mobile": {
                padding: "10px"
            }
        }
    };
});
const ClickableIcon = ({ accessibilityLabel, className, icon, id, onClick, iconClassName, colorInClass = true }) => {
    const { classes: styles, cx } = useStyles();
    const isMobile = isMobileBrowser();
    return ((React.createElement("button", { "aria-label": accessibilityLabel, className: cx(styles.button, isMobile && "is-mobile", className), id: id, onClick: onClick },
        React.createElement(Icon, { colorInClass: colorInClass, className: iconClassName, size: 24, src: icon }))));
};
export default ClickableIcon;
